// This code automatically imports the file applicationConfig.js
// and merges this with any account application config (if available)
function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object'
  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key]
      const oVal = obj[key]
      if ((Array.isArray(pVal) && Array.isArray(oVal)) || (isObject(pVal) && isObject(oVal))) {
        prev[key] = mergeDeep(pVal, oVal)
      } else {
        prev[key] = oVal
      }
    })
    return Array.isArray(obj) ? Object.values(prev) : prev
  }, {})
}

// merge new application configs into user configs
// remain existing value in user configs
function mergeConfigs(userConfigs, appConfigs) {
  let result = []
  appConfigs.forEach(appConfig => {
    const userConfig = userConfigs.find(c => c.configName == appConfig.configName)
    if (userConfig) {
      // merge deep for existing userconfig
      result.push(mergeDeep(appConfig, userConfig))
    } else {
      // add new app configs to user configs
      result.push(appConfig)
    }
  })

  userConfigs.forEach(config => {
    const userConfig = result.some(c => c.configName == config.configName)
    if (!userConfig) {
      // add old/no longer existing node from user config back into total config
      result.push(config)
    }
  })
  return result
}

export default {
  async bootstrapInit(userConfigs) {
    let applicationConfig
    await fetch('/assets/v1/applicationConfig.json')
      .then(r => r.json())
      .then(payload => {
        applicationConfig = payload
      })

    if (userConfigs == undefined || userConfigs == null) {
      return applicationConfig
    }

    // if we have a userConfig, merge with userConfig leading by merging new (not yet existing values) into the userconfig
    return mergeConfigs(userConfigs, applicationConfig)
  },
  get(configName, key, defaultValue) {
    let item = undefined
    for (let i = 0; i < window.adacado.applicationConfig.length; i++) {
      if (window.adacado.applicationConfig[i].configName === configName) {
        item = window.adacado.applicationConfig[i].values
        break
      }
    }
    // The high level key was not found, exit:
    if (item == undefined) {
      return defaultValue
    }

    for (let i = 0; i < item.length; i++) {
      if (item[i].key == key) {
        return item[i].value // This return short-circuits loop, so no need for a break
      }
    }
    return defaultValue
  },
  set(configName, key, newValue) {
    // **this set function will not mutate any information in applicationconfig.json**
    // it is used for other fems that needs a quick way to set a newValue to application config following configName and key
    // so we have a set function in a sigle resource instead of having a set function in each fems
    // this function will return a whole application config object with new value updated
    // other fems can use this return value to update new application config and save it into the account in specific fems
    let item = undefined
    const appConfigClone = JSON.parse(JSON.stringify(window.adacado.applicationConfig))
    for (let i = 0; i < appConfigClone.length; i++) {
      if (appConfigClone[i].configName === configName) {
        item = appConfigClone[i].values
        break
      }
    }
    // The high level key was not found, exit:
    if (item == undefined) {
      return
    }

    for (let i = 0; i < item.length; i++) {
      if (item[i].key == key) {
        item[i].value = newValue // This return short-circuits loop, so no need for a break
        // apply the new value to the window application config so that it is readily available
        window.adacado.applicationConfig = appConfigClone
        return appConfigClone
      }
    }
  },
}
